import React, { useEffect, useState } from "react";
import styles from "./BetaToggle.module.css";
import LoaderComp from "../../../LoaderComp";
import modalContentSty from "../LeadGenBotSettings/ModalContent.module.css";
import { Modal } from "../../../NewCreateAppF/CreateApp";
import { useTenantPlan } from "../../../../hooks/useTenantPlan";

const environment = `${process.env.REACT_APP_STAGE_ENV}`;
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

const ManageExtensions = ({
  betaToggle,
  region,
  app_name,
  tenant_name,
  tenant_id,
  tenantPlan,
}) => {
  const { plan: tenantPlanFromHook, loading: planLoading } = useTenantPlan();

  console.log(tenantPlan, "AREWH", region);
  const [loading, setLoading] = useState(true);
  const [tenant_plan, setTenant_plan] = useState("BASIC");
  const [toggleState, setToggleState] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // 🔑 toggles node + children
  const toggleWithChildren = (node, newState, plan, cascade = true) => {
    const updatedNode = { ...node, enable: newState };

    if (cascade && node.settings) {
      updatedNode.settings = Object.fromEntries(
        Object.entries(node.settings).map(([childKey, childValue]) => {
          if (plan === "BASIC" && childValue.type === "ADVANCE") {
            return [childKey, childValue]; // skip ADVANCE for BASIC plan
          }
          return [
            childKey,
            childValue.enable !== undefined
              ? toggleWithChildren(childValue, newState, plan, true)
              : childValue,
          ];
        }),
      );
    }
    return updatedNode;
  };

  // 🔑 toggles node + syncs parents
  const toggleNodeWithParents = (state, fullKey, newState, plan) => {
    const keys = fullKey.split(".");

    const updateRecursively = (obj, depth = 0) => {
      const key = keys[depth];

      if (!obj[key]) return obj; // guard

      // last key → toggle the node
      if (depth === keys.length - 1) {
        return {
          ...obj,
          [key]: toggleWithChildren(obj[key], newState, plan, depth === 0),
        };
      }

      // go deeper
      const childUpdated = updateRecursively(
        obj[key].settings || obj[key],
        depth + 1,
      );

      // rebuild this node
      const updatedNode = {
        ...obj[key],
        settings: obj[key].settings ? { ...childUpdated } : obj[key].settings,
      };

      // bubble parent enable state
      // bubble parent enable state
      if (updatedNode.settings) {
        const values = Object.values(updatedNode.settings);

        // 🔑 exclude ADVANCE children if plan is BASIC
        const relevantChildren =
          tenant_plan === "BASIC"
            ? values.filter((c) => c.type !== "ADVANCE")
            : values;

        const anyEnabled = relevantChildren.some((c) => c.enable);
        updatedNode.enable = anyEnabled;
      }

      return { ...obj, [key]: updatedNode };
    };

    return updateRecursively(state, 0);
  };

  const filterByPlan = (features) => features || {};

  // useEffect(() => {
  //   const fetchPlan = async () => {
  //     try {
  //       const response = await fetch(
  //         `https://mgmt-util2.${backend_api_base_url}/get_tenant_plan?tenant_id=${tenant_id}`,
  //         {
  //           method: "GET",
  //           headers: { "Content-Type": "application/json" },
  //         },
  //       );
  //       const data = await response.json();
  //       return data;
  //     } catch (error) {
  //       console.error("Error fetching plan:", error);
  //       return { data: "BASIC" };
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   const init = async () => {
  //     const planResponse = await fetchPlan();
  //     const plan = planResponse.data.plan;
  //     setTenant_plan(plan);
  //     const filtered = filterByPlan(betaToggle || {});
  //     setToggleState(filtered);
  //   };
  //   init();
  // }, [tenant_id, betaToggle]);

  useEffect(() => {
    // ✅ Update tenant_plan when hook data changes
    if (tenantPlanFromHook) {
      setTenant_plan(tenantPlanFromHook);
    }

    const filtered = filterByPlan(betaToggle || {});
    setToggleState(filtered);
    setLoading(false);
  }, [tenant_id, betaToggle, tenantPlanFromHook]);

  const proceedApply = async () => {
    const token = localStorage.getItem("token");
    const headersList = {
      Accept: "*/*",
      Authorization: token,
      "Content-Type": "application/json",
    };

    const bodyContent = JSON.stringify({ feature: toggleState });

    try {
      const region_prefix = region.toLowerCase();
      await fetch(
        `https://${region_prefix}.apps2.${backend_api_base_url}/update_app?act_type=tenant&app_name=${app_name}`,
        { method: "PUT", body: bodyContent, headers: headersList },
      );

      window.MyPackage.processHardReset(token, app_name, region.toLowerCase());
      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 6000);
    } catch (error) {
      console.error("Error updating settings:", error);
    }
  };

  const handleApply = async () => {
    const requestOptions = { method: "GET", redirect: "follow" };
    const res = await fetch(
      `https://mgmt-util2.${backend_api_base_url}/get_global_settings?tenant_id=${tenant_id}`,
      requestOptions,
    );
    const globalSettings = await res.json();

    console.log(
      JSON.stringify(toggleState),
      "toggleState",
      JSON.stringify(globalSettings),
      "globalSettings",
    );

    // 🔑 Validation: check advance_email_notifications dependency
    const localAdvEmail = toggleState?.advance_email_notifications?.enable;
    const globalAdvEmail =
      globalSettings?.data?.advance_email_notifications?.enable;

    if (localAdvEmail && !globalAdvEmail) {
      alert(
        "Advance Email Notifications must be enabled in Global Settings before you can enable it here.",
      );
      return; // stop further execution
    }

    const hasHardResetRequired = Object.values(toggleState).some((feature) => {
      if (feature?.side_effects?.hard_reset_required) return true;
      return Object.values(feature?.settings || {}).some(
        (setting) => setting?.side_effects?.hard_reset_required,
      );
    });

    if (hasHardResetRequired) {
      setShowConfirmModal(true);
      return;
    }
    await proceedApply();
  };

  const confirmUpdate = (confirmed) => {
    setShowConfirmModal(false);
    if (confirmed) proceedApply();
  };

  const handleNumericChange = (fullKey, valueKey, newValue) => {
    setToggleState((prev) => {
      const newState = structuredClone(prev);
      const keys = fullKey.split(".");
      let current = newState;

      for (let i = 0; i < keys.length; i++) {
        if (!current[keys[i]]) return prev; // ⛔ guard against undefined
        if (i < keys.length - 1 && current[keys[i]].settings?.[keys[i + 1]]) {
          current = current[keys[i]].settings;
        } else {
          current = current[keys[i]];
        }
      }

      if (current && current[valueKey] !== undefined) {
        current[valueKey] = newValue;
      }
      return newState;
    });
  };

  const renderToggleItems = (toggleState, parentKey = null) => (
    <div className={styles["betatoggles-cards"]}>
      {Object.entries(toggleState).map(([key, value]) => {
        const fullKey = parentKey ? `${parentKey}.${key}` : key;
        const isNumericSetting =
          value.max_msg_count !== undefined ||
          Object.keys(value).some(
            (k) => typeof value[k] === "number" && k !== "enable",
          );
        if (isNumericSetting && parentKey) return null;

        const isAdvance = value.type === "ADVANCE";
        const isDisabledForPlan = tenant_plan === "BASIC" && isAdvance;
        const isDisabledForBeta =
          environment === "prod" && value.beta_feature === true;
        const finalDisabled = isDisabledForPlan || isDisabledForBeta;

        return (
          <div
            className={styles.betatoggleBox}
            key={fullKey}
            data-feature={key} // Add data attribute for feature identification
          >
            <div className={styles.toggleText}>
              <p className={styles.description}>
                <strong className={styles.keyLabel}>
                  {key.replace(/_/g, " ")}:
                </strong>{" "}
                <span className={styles.enableStatus}>
                  {value.enable !== undefined
                    ? value.enable
                      ? "Enabled"
                      : "Disabled"
                    : "Setting"}
                </span>
              </p>
              <p className={styles.description}>{value.desc}</p>
              {isAdvance && tenant_plan === "BASIC" && (
                <p className={styles.description} style={{ color: "red" }}>
                  (Available only on ADVANCE plan)
                </p>
              )}
              {isDisabledForBeta && (
                <p className={styles.description} style={{ color: "red" }}>
                  (Beta feature – disabled in prod)
                </p>
              )}
            </div>

            {value.enable !== undefined && (
              <button
                className={`${styles.toggleButton} ${styles.anotherStyle}`}
                disabled={finalDisabled}
                onClick={() =>
                  setToggleState((prev) =>
                    toggleNodeWithParents(
                      prev,
                      fullKey,
                      !value.enable,
                      tenantPlan,
                    ),
                  )
                }
                data-testid={`toggle-${key}`} // Add test ID for easier selection
              >
                {value.enable ? "Disable" : "Enable"}
              </button>
            )}

            {value.settings && Object.keys(value.settings).length > 0 && (
              <div className={styles.nestedSettings}>
                <h4 className={styles.subtitle}>Settings:</h4>
                {Object.entries(value.settings).map(
                  ([settingKey, settingValue]) => {
                    const settingFullKey = `${fullKey}.${settingKey}`;
                    const isSettingNumeric =
                      settingValue.max_msg_count !== undefined ||
                      Object.keys(settingValue).some(
                        (k) =>
                          typeof settingValue[k] === "number" && k !== "enable",
                      );
                    const isDisabledByParent =
                      value.sub_settings_enable === false ||
                      (tenant_plan === "BASIC" &&
                        settingValue.type === "ADVANCE") ||
                      (environment === "prod" &&
                        settingValue.beta_feature === true);

                    return (
                      <div
                        className={styles.settingItem}
                        key={settingFullKey}
                        data-setting={settingKey} // Add data attribute for setting identification
                      >
                        <p className={styles.description}>
                          <strong className={styles.keyLabel}>
                            {settingKey.replace(/_/g, " ")}:
                          </strong>{" "}
                          {settingValue.desc}
                          {tenant_plan === "BASIC" &&
                            settingValue.type === "ADVANCE" && (
                              <span style={{ color: "red" }}>
                                {" "}
                                (ADVANCE only)
                              </span>
                            )}
                          {environment === "prod" &&
                            settingValue.beta_feature === true && (
                              <span style={{ color: "red" }}>
                                {" "}
                                (Beta feature – disabled in prod)
                              </span>
                            )}
                        </p>

                        {isSettingNumeric ? (
                          <div className={styles.numericSetting}>
                            {Object.entries(settingValue).map(
                              ([valKey, valValue]) => {
                                if (typeof valValue === "number") {
                                  return (
                                    <div
                                      key={valKey}
                                      className={styles.numericControl}
                                    >
                                      <label>
                                        {valKey.replace(/_/g, " ")}:
                                      </label>
                                      <div className={styles.numericInputGroup}>
                                        <button
                                          disabled={isDisabledByParent}
                                          onClick={() => {
                                            handleNumericChange(
                                              settingFullKey,
                                              valKey,
                                              Math.max(0, valValue - 1),
                                            );
                                          }}
                                        >
                                          -
                                        </button>
                                        <input
                                          type="number"
                                          value={valValue}
                                          min="0"
                                          disabled={isDisabledByParent}
                                          onChange={(e) => {
                                            handleNumericChange(
                                              settingFullKey,
                                              valKey,
                                              Math.max(
                                                0,
                                                parseInt(e.target.value) || 0,
                                              ),
                                            );
                                          }}
                                        />
                                        <button
                                          disabled={isDisabledByParent}
                                          onClick={() => {
                                            handleNumericChange(
                                              settingFullKey,
                                              valKey,
                                              valValue + 1,
                                            );
                                          }}
                                        >
                                          +
                                        </button>
                                      </div>
                                    </div>
                                  );
                                }
                                return null;
                              },
                            )}
                          </div>
                        ) : settingValue.enable !== undefined ? (
                          <button
                            className={styles.toggleButton}
                            disabled={isDisabledByParent}
                            onClick={() =>
                              setToggleState((prev) =>
                                toggleNodeWithParents(
                                  prev,
                                  settingFullKey,
                                  !settingValue.enable,
                                  tenantPlan,
                                ),
                              )
                            }
                            data-testid={`toggle-${settingKey}`} // Add test ID for easier selection
                          >
                            {settingValue.enable ? "Disable" : "Enable"}
                          </button>
                        ) : null}
                      </div>
                    );
                  },
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );

  if (loading || planLoading)
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        <LoaderComp />
      </div>
    );

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Enable ManageExtensions as per need</h2>
      <div className={styles.content}>
        <div className={styles.applyButtonContainer}>
          <button className={styles.applyButton} onClick={handleApply}>
            Apply
          </button>
        </div>
        <div className={styles.toggles}>
          <div className={styles.column}>{renderToggleItems(toggleState)}</div>
        </div>
      </div>
      <Modal
        isOpen={showConfirmModal}
        onClose={() => confirmUpdate(false)}
        hideCloseButton={true}
        content={
          <div className={modalContentSty.modalContent}>
            <div className={modalContentSty.modalContentWrap}>
              <div className={modalContentSty.modalContentIc}>⚠️</div>
              <p className={modalContentSty.modalMessage}>
                All the clients would be rebooted! Do you want to continue?
              </p>
            </div>
            <div className={modalContentSty.modalActions}>
              <button
                className={`${modalContentSty.modalButton} ${modalContentSty.cancelBtn}`}
                onClick={() => confirmUpdate(false)}
              >
                Cancel
              </button>
              <button
                className={`${modalContentSty.modalButton} ${modalContentSty.okBtn}`}
                onClick={() => confirmUpdate(true)}
              >
                Ok
              </button>
            </div>
          </div>
        }
      />
    </div>
  );
};

export default ManageExtensions;
